import axios from 'axios'
// import router from '../router'

import {
    apiURL, smsURL, localStorageKey, devOpsURL, gaURL,
    apiJavaURL, videoEncodeApi, gaJavaURL
} from "./config";
import EventBus from "@/utils/event-bus";
import {clearSession, getIsSessionInvalidated, logout} from "@/utils/logout";
import Swal from "sweetalert2";

import moment from 'moment';


const onUnauthorized = (error) => {
    EventBus.$emit("changeStyleLoading", false);
    EventBus.$emit('changeLoading', false);
    EventBus.$emit('apiLoading', false);

    if (getIsSessionInvalidated()) {
        return;
    }

    logout();
};

let isOtherPlatformLogoutAlertOpen = false;

const logApiError = (error, fallback = {}) => {
    const response = error?.response || fallback.response;
    const config = error?.config || fallback.config;

    console.error('API ERROR', {
        url: config?.url,
        method: config?.method,
        status: response?.status,
        data: response?.data,
        message: error?.message,
        code: error?.code,
    });
};

const handleOtherPlatformLogout = () => {
    if (isOtherPlatformLogoutAlertOpen) {
        return true;
    }

    isOtherPlatformLogoutAlertOpen = true;
    clearSession();
    EventBus.$emit("changeStyleLoading", false);
    EventBus.$emit('changeLoading', false);
    EventBus.$emit('apiLoading', false);

    Swal.fire({
        title: '',
        html: '현재 계정의 다른 플랫폼 로그아웃으로 인하여<br>다시 로그인이 필요합니다.',
        confirmButtonText: '닫기',
        customClass: 'alert-default',
        allowOutsideClick: false,
        allowEscapeKey: false,
    }).then(() => {
        isOtherPlatformLogoutAlertOpen = false;
        location.href = '/';
    });

    return true;
};

const handleCommonApiCode = (data) => {
    if (!data || typeof data.code === 'undefined') {
        return false;
    }

    if (data.code === -672) {
        return handleOtherPlatformLogout();
    }

    return false;
};

const RESULTCODE = {
    INVALIDE_PARAMETER: "INVALID_PARAMETER",
    SUCCEEDED: "SUCCEEDED",
    ERROR: "ERROR"
}

const RESULTDEFUALTDATA = {data: {Data: {Result: {Info: {status: false, type: null}}}}}
const getResultDefaultData = (type) => {
    let result = Object.assign({}, RESULTDEFUALTDATA)
    result.data.Data.Result.Info.type = type;
    return result;
}
export const setAuthInHeader = token => {
    axios.defaults.headers.common['Authorization'] = token ? `Bearer ${token}` : '';
};

export const request = {
    javaGet(path, params = null, config = {}) {
        return axios.get(`${apiJavaURL + path}`, {...config, params})
                .then(res => {
                    if (handleCommonApiCode(res.data)) {
                        return res;
                    }
                    if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                        alert("문제가 발생했습니다. 다시 시도해 주세요.");
                        router.push("/");
                        return res;
                    } else return res;
                }).catch((error) => {
                    const response = error?.response;
                    if (response && handleCommonApiCode(response.data)) {
                        return response;
                    }
                    logApiError(error);
                    return response
                })
    },
    javaPost(path, data, config = {}) {
        return axios.post(`${apiJavaURL + path}`, data, config)
            .then(res => {
                if (handleCommonApiCode(res.data)) {
                    return res;
                }
                let now = moment().format("YYYY-MM-DD HH:mm:ss");
                window.localStorage.setItem(localStorageKey + 'useTime', '"' + String(now) + '"');
                return res;
            }).catch((error) => {
                const response = error?.response;
                if (response == undefined) {
                    logApiError(error);
                    return response
                }
                if (handleCommonApiCode(response.data)) {
                    return response;
                }
                logApiError(error);
                const {status} = response.data.code;

                if (response == undefined || status === 201 || status === 202 || status === 203 || status === 401) {
                    return onUnauthorized(error);
                }
                return response
            })
    },
    javaDelete(path, params = null, config = {}) {
        return axios.delete(`${apiJavaURL + path}`, {...config, data: params})
            .then(res => {
                if (handleCommonApiCode(res.data)) {
                    return res;
                }
                let now = moment().format("YYYY-MM-DD HH:mm:ss");
                window.localStorage.setItem(localStorageKey + 'useTime', '"' + String(now) + '"');
                return res;
            }).catch((error) => {
                const response = error?.response;
                if (response && handleCommonApiCode(response.data)) {
                    return response;
                }
                logApiError(error);
                const {status} = response.data.code;
                if (status === 201 || status === 202 || status === 203 || status === 401) {
                    return onUnauthorized(error);
                }
                return response
            })
    },
    javaPut(path, data, config = {}) {
        return axios.put(`${apiJavaURL + path}`, data, config)
            .then(res => {
                if (handleCommonApiCode(res.data)) {
                    return res;
                }
                let now = moment().format("YYYY-MM-DD HH:mm:ss");
                window.localStorage.setItem(localStorageKey + 'useTime', '"' + String(now) + '"');
                return res;
            }).catch((error) => {
                const response = error?.response;
                if (response && handleCommonApiCode(response.data)) {
                    return response;
                }
                logApiError(error);
                const {status} = response.data.code;
                if (status === 201 || status === 202 || status === 203 || status === 401) {
                    return onUnauthorized(error);
                }
                return response
            })
    },
    javaPatch(path, data, config = {}) {
        return axios.patch(`${apiJavaURL + path}`, data, config)
            .then(res => {
                if (handleCommonApiCode(res.data)) {
                    return res;
                }
                let now = moment().format("YYYY-MM-DD HH:mm:ss");
                window.localStorage.setItem(localStorageKey + 'useTime', '"' + String(now) + '"');
                return res;
            }).catch((error) => {
                const response = error?.response;
                if (response && handleCommonApiCode(response.data)) {
                    return response;
                }
                logApiError(error);
                const {status} = response.data.code;
                if (status === 201 || status === 202 || status === 203 || status === 401) {
                    return onUnauthorized(error);
                }
                return response
            })
    },

    get(path, params = null) {
        return axios.get(`${apiURL + path}`, {params: params})
            .then(res => {
                if (handleCommonApiCode(res.data)) {
                    return res;
                }
                if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                    alert("문제가 발생했습니다. 다시 시도해 주세요.");
                    router.push("/");
                    return res;
                } else return res;
            })
            .catch((error) => {
                const response = error?.response;
                if (response && handleCommonApiCode(response.data)) {
                    return response;
                }
                logApiError(error);
                //location.href = '/'
                const {status} = response;
                if (status === 401) {
                    return onUnauthorized(error);
                } else if (status === 'Errored') {
                    alert("잘못된 정보입니다.");
                }
                throw Error(response);
            });
    },
    post(path, data) {
        return axios
            .post(`${apiURL + path}`, data)
            .then((res) => {
                if (handleCommonApiCode(res.data)) {
                    return res;
                }
                let now = moment().format("YYYY-MM-DD HH:mm:ss");
                window.localStorage.setItem(localStorageKey + 'useTime', '"' + String(now) + '"');
                if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                    alert("문제가 발생했습니다. 다시 시도해주세요.");
                    EventBus.$emit("changeStyleLoading", false);
                    // //location.href = '/'
                    return res;
                } else {
                    if (res.data.Data.hasOwnProperty('Result') && res.data.Data.Result.Info.type === -270) {
                        logout();
                    } else {
                        EventBus.$emit("resetLogoutTimer", true);
                        return res;
                    }
                }
            })
            .catch((error) => {
                const response = error?.response;
                if (response && handleCommonApiCode(response.data)) {
                    return response;
                }
                logApiError(error);
                EventBus.$emit("changeStyleLoading", false);
                //location.href = '/'
                const {status} = response || {status: null};
                if (status === 401) {
                    return onUnauthorized(error);
                } else if (status === Errored) {
                    alert("잘못된 정보입니다.");
                }
                throw Error(response);
            });
    },
    smsPost(path, data) {
        return axios
            .post(`${smsURL + path}`, data)
            .then((res) => {
                if (handleCommonApiCode(res.data)) {
                    return res;
                }
                let now = moment().format("YYYY-MM-DD HH:mm:ss");
                window.localStorage.setItem(localStorageKey + 'useTime', '"' + String(now) + '"');
                if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                    alert("문제가 발생했습니다. 다시 시도해주세요.");
                    EventBus.$emit("changeStyleLoading", false);
                    //location.href = '/'
                    return res;
                } else {
                    if (res.data.Data.hasOwnProperty('Result') && res.data.Data.Result.Info.type === -270) {
                        logout();
                    } else {
                        EventBus.$emit("resetLogoutTimer", true);
                        return res;
                    }
                }
            })
            .catch((error) => {
                const response = error?.response;
                if (response && handleCommonApiCode(response.data)) {
                    return response;
                }
                logApiError(error);
                EventBus.$emit("changeStyleLoading", false);
                //location.href = '/'
                const {status} = response || {status: null};
                if (status === 401) {
                    return onUnauthorized(error);
                } else if (status === Errored) {
                    alert("잘못된 정보입니다.");
                }
                throw Error(response);
            });
    },
    snsPost(path, data) {
        return axios
            .post(`${apiURL + path}`, data)
            .then((res) => {
                if (handleCommonApiCode(res.data)) {
                    return res;
                }
                if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                    EventBus.$emit("changeStyleLoading", false);
                    return res;
                } else {
                    return res;
                }
            })
            .catch((error) => {
                const response = error?.response;
                if (response && handleCommonApiCode(response.data)) {
                    return response;
                }
                logApiError(error);
                EventBus.$emit("changeStyleLoading", false);

                throw Error(error);
            });
    },
    devOpsPost(path, data) {
        return axios
            .post(`${devOpsURL + path}`, data)
            .then((res) => {
                if (handleCommonApiCode(res.data)) {
                    return res;
                }
                if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                    alert("문제가 발생했습니다. 다시 시도해주세요.");
                    EventBus.$emit("changeStyleLoading", false);
                    return res;
                } else {
                    if (res.data.Data.hasOwnProperty('Result') && res.data.Data.Result.Info.type === -270) {
                        logout();
                    } else {
                        EventBus.$emit("resetLogoutTimer", true);
                        return res;
                    }
                }
            })
            .catch((error) => {
                const response = error?.response;
                if (response && handleCommonApiCode(response.data)) {
                    return response;
                }
                logApiError(error);
                // EventBus.$emit("changeStyleLoading", false);
                // //location.href = '/'
                // const {status} = response || {status: null};
                // if (status === 401) {
                //     return onUnauthorized();
                // } else if (status === Errored) {
                //     alert("잘못된 정보입니다.");
                // }
                // throw Error(response);
            });
    },
    gaGet(path, params = null) {
        return axios.get(`${gaURL + path}`, {params: params}).then((res) => {
            if (handleCommonApiCode(res.data)) {
                return res;
            }
            return res;
        })
            .catch((error) => {
                const response = error?.response;
                if (response && handleCommonApiCode(response.data)) {
                    return response;
                }
                logApiError(error);
                return response;
            });
    },
    gaPost(path, data) {
        return axios.post(`${gaURL + path}`, data)
            .then((res) => {
                if (handleCommonApiCode(res.data)) {
                    return res;
                }
                return res;
            })
            .catch((error) => {
                const response = error?.response;
                if (response && handleCommonApiCode(response.data)) {
                    return response;
                }
                logApiError(error);
                return response;
            });
    },
    encodeVideo(data) {
        let config = {
            headers: {
                "Content-Type": `application/json`,
                Authorization: "",
            },
        };
        return axios
            .post(videoEncodeApi, JSON.stringify(data), config)
            .then((res) => {
                if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                    alert("문제가 발생했습니다. 다시 시도해주세요.");
                    return res;
                } else {
                    if (res.data.Data.hasOwnProperty('Result') && res.data.Data.Result.Info.type === -270) {
                        logout();
                    } else {
                        EventBus.$emit("resetLogoutTimer", true);
                        return res;
                    }
                }
            })
            .catch((error) => {
                const response = error?.response;
                logApiError(error);
                const {status} = response || {status: null};
                if (status === 400 || status === 401) {
                    return onUnauthorized(error);
                } else if (status != null) {
                    alert("잘못된 정보입니다.");
                }
                let result = getResultDefaultData(status);
                //throw Error(response)
                return result;
            });
    },
    gaJavaGet(path, params = null) {
        return axios.get(`${gaJavaURL + path}`, {params: params}).then((res) => {
            return res;
        }).catch((error) => {
            logApiError(error);
        });
    },
    gaJavaPost(path, data) {
        return axios.post(`${gaJavaURL + path}`, data).then((res) => {
            return res;
        }).catch((error) => {
            logApiError(error);

        });
    },
    gaJavaPut(path, data) {
        return axios.put(`${gaJavaURL + path}`, data).then((res) => {
            return res;
        }).catch((error) => {
            logApiError(error);
        });
    },
    gaJavaDelete(path, data) {
        return axios.delete(`${gaJavaURL + path}`, {data: data}).then((res) => {
            return res;
        }).catch((error) => {
            logApiError(error);

        });
    },
};
